import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_STATS_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS,
  KEY_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS,
} from '../constats';
import { MOCK_RESPONSE_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS } from '../mocks';

type RequestGetSurveyCampaignByIdResponsesStats = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_STATS_PATH_KEY
>['request']['path'];

type ResponseGetSurveyCampaignByIdResponsesStats = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_STATS_PATH_KEY
>['response']['body'];

type CallParamsGetSurveyCampaignByIdResponsesStats = Omit<
  RequestGetSurveyCampaignByIdResponsesStats,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetSurveyCampaignByIdResponsesStats =
  ResponseGetSurveyCampaignByIdResponsesStats;

type CallErrorGetSurveyCampaignByIdResponsesStats = GenericApiError;

type CallSelectorsGetSurveyCampaignByIdResponsesStats = {
  completedSurveys: number;
  totalCompletedEmployees: number;
  totalInvitation: number;
};

export const getSurveyCampaignByIdResponsesStatsCall = createGeneralCall<
  CallParamsGetSurveyCampaignByIdResponsesStats,
  CallResponseGetSurveyCampaignByIdResponsesStats,
  CallErrorGetSurveyCampaignByIdResponsesStats,
  CallSelectorsGetSurveyCampaignByIdResponsesStats
>({
  id: KEY_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS,
  method: 'get',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS(org, payload.campaignId);
    },
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS
    : undefined,
  selectors: {
    completedSurveys: ({ selectors }) =>
      createSelector(selectors.response, res => res?.completedSurveys || 0),
    totalCompletedEmployees: ({ selectors }) =>
      createSelector(selectors.response, res => res?.totalCompletedEmployees || 0),
    totalInvitation: ({ selectors }) =>
      createSelector(selectors.response, res => res?.totalInvitation || 0),
  },
});
